import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  error: '',
  data: [],
  total_results: 0,
  page: 1,
  has_next: false,
  has_prev: false,
  total_pages: 0,
  filters: { source_system: '', search: '' },
  selectedItem: null,
  createLoading: false,
  updateLoading: false,
}

const rewardUsersSlice = createSlice({
  name: 'rewardUsers',
  initialState,
  reducers: {
    tryFetchUsers: () => {},
    tryFetchUserById: () => {},
    tryCreateUser: () => {},
    tryUpdateUser: () => {},
    setUsers: (state, action) => {
      return {
        ...state,
        data: action.payload.data || [],
        total_results: action.payload.total_results || 0,
        page: action.payload.page || 1,
        has_next: action.payload.has_next || false,
        has_prev: action.payload.has_prev || false,
        total_pages: action.payload.total_pages || 0,
        loading: false,
        error: '',
      }
    },
    setUserDetail: (state, action) => {
      return { ...state, selectedItem: action.payload, loading: false, error: '' }
    },
    setLoading: (state, action) => {
      return { ...state, loading: action.payload }
    },
    setError: (state, action) => {
      return { ...state, error: action.payload, loading: false }
    },
    setCreateLoading: (state, action) => {
      return { ...state, createLoading: action.payload }
    },
    setUpdateLoading: (state, action) => {
      return { ...state, updateLoading: action.payload }
    },
    setFilters: (state, action) => {
      return { ...state, filters: { ...state.filters, ...action.payload }, page: 1 }
    },
    resetUsersState: () => initialState,
  },
})

export const {
  tryFetchUsers,
  tryFetchUserById,
  tryCreateUser,
  tryUpdateUser,
  setUsers,
  setUserDetail,
  setLoading,
  setError,
  setCreateLoading,
  setUpdateLoading,
  setFilters,
  resetUsersState,
} = rewardUsersSlice.actions

export default rewardUsersSlice.reducer